import Layout from '@layout/Index'

export const financeConfig = [
  {
    path: '/finance-config',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'approval-value',
      },
      {
        path: 'approval-value',
        component: () => import(/* webpackChunkName: "finance-config-table" */ './pages/FinanceApprovalValueConfig.vue'),
        meta: {
          title: '审批起始值设置',
        },
      },
      {
        path: 'subject-management',
        component: () => import(/* webpackChunkName: "finance-config-table" */ './pages/PaymentSubjectManagement.vue'),
        meta: {
          title: '付款科目管理',
        },
      },
      {
        path: 'second-subject-management',
        component: () => import(/* webpackChunkName: "finance-config-table" */ './pages/PaymentSecondSubjectManagement.vue'),
        meta: {
          title: '付款科目管理',
        },
      },
      {
        path: 'subject-relationships-management',
        component: () => import(/* webpackChunkName: "finance-config-table" */ './pages/PaymentSubjectRelationshipsManagement.vue'),
        meta: {
          title: '付款科目管理',
        },
      },
      {
        path: 'subject-relationships-management-form/:id',
        component: () => import(/* webpackChunkName: "finance-config-table" */ './pages/PaymentSubjectRelationshipsManagementForm.vue'),
        meta: {
          title: '付款科目管理',
        },
      },
      {
        path: 'company-account',
        component: () => import(/* webpackChunkName: "finance-config-table" */ './pages/FinanceCompanyAccount.vue'),
        meta: {
          title: '公司管理',
        },
      },
      {
        path: 'invoice-name-management',
        component: () => import(/* webpackChunkName: "invoicing-name-management" */ './pages/invoice-name/FinanceInvoiceNameTable.vue'),
        meta: {
          title: '开票名称管理',
        },
      },
      {
        path: 'invoice-category',
        component: () => import(/* webpackChunkName: "invoicing-category-management" */ './pages/invoice-name/FinanceInvoiceCategoryTable.vue'),
        meta: {
          title: '开票名称类别列表',
        },
      },
      {
        path: 'invoice-name-batch-create',
        component: () => import(/* webpackChunkName: "invoicing-name-batch-create" */ './pages/invoice-name/FinanceInvoiceNameBatchForm.vue'),
        meta: {
          type: 'batch_create',
          title: '批量添加开票名称',
        },
      },
      {
        path: 'invoice-name-batch-update',
        component: () => import(/* webpackChunkName: "invoicing-name-batch-create" */ './pages/invoice-name/FinanceInvoiceNameBatchForm.vue'),
        meta: {
          type: 'batch_edit',
          title: '批量更新开票名称',
        },
      },
      {
        path: 'invoice-name-create',
        component: () => import(/* webpackChunkName: "invoicing-name-batch-create" */ './pages/invoice-name/FinanceInvoiceNameForm.vue'),
        meta: {
          type: 'create',
          title: '添加开票名称',
        },
      },
      {
        path: 'invoice-name-update/:id',
        component: () => import(/* webpackChunkName: "invoicing-name-batch-create" */ './pages/invoice-name/FinanceInvoiceNameForm.vue'),
        meta: {
          type: 'edit',
          title: '更新开票名称',
        },
      },
      {
        path: 'department-management',
        component: () => import(/* webpackChunkName: "department-management" */ './pages/FinanceDepartmentManagement.vue'),
        meta: {
          title: '部门管理',
        },
      },
      {
        path: 'department-management/batch-create',
        component: () => import(/* webpackChunkName: "department-management-batch-create" */ './pages/FinanceDepartmentBatchForm.vue'),
        meta: {
          title: '批量添加部门',
        },
      },
      {
        path: 'department-management/batch-create-job',
        component: () => import(/* webpackChunkName: "department-management-batch-create-job" */ './pages/FinanceDepartmentJobBatchForm.vue'),
        meta: {
          title: '批量添加岗位',
        },
      },
      {
        path: 'department-management/:department_id/jobs',
        component: () => import(/* webpackChunkName: "department-management-job-table" */ './pages/FinanceDepartmentJobTable.vue'),
        meta: {
          title: '岗位管理',
        },
      },
      {
        path: 'public-accounts',
        component: () => import(/* webpackChunkName: "finance-config-table" */ './pages/PaymentSubjectManagement.vue'),
        meta: {
          title: '对公账户列表',
        },
      },
      {
        path: 'employee-accounts',
        component: () => import(/* webpackChunkName: "finance-config-table" */ './pages/PaymentSubjectManagement.vue'),
        meta: {
          title: '员工账户列表',
        },
      },
      {
        path: 'finance-email-notify',
        component: () => import(/* webpackChunkName: "finance-email-notify" */ './pages/FinanceEmailNotify.vue'),
        meta: {
          title: '财务邮件通知设置',
        },
      },
      {
        path: 'tax-panel',
        component: () => import(/* webpackChunkName: "taxPanel" */ './pages/BaiWangCfgForm.vue'),
        meta: {
          title: '百旺自动开票配置项设置',
        },
      },
    ],
  },
]

export const financeConfigCompanyAccountManagement = [
  {
    path: '/finance-config/company-account-management',
    component: Layout,
    children: [
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "company-account-management-table1" */ './pages/company-account-management/CompanyAccountManagementTable.vue'),
        meta: {
          title: '账户管理',
        },
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/views/finance-config/finance-config.route.js